export default "__VITE_ASSET__DSkGe3PY__"